import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Text } from '@amzn/dvui/dist/Text'
import { PrimaryButton } from '@amzn/dvui/dist/Button'
import * as st from './otherFormats.module.scss'
import { DpWidgetContext } from '../../utils/dpWidgetContext'

export interface IOtherFormatsProps {
  content?: WpsRuntime.atv.wps.OtherFormatsModelProps
}

export const OtherFormats = ({content}: IOtherFormatsProps) => {
  const { getString } = React.useContext(DpWidgetContext)
  if (!content || !content.actions.length) {
    return null
  }
  return <div data-automation-id="other-formats">
    <h1 className={st.header}> {getString('DV_DP_CL_other_formats_title')} </h1>
    {content.actions.map((action: WpsRuntime.atv.wps.FormatActionProps, idx) => {
      return <div className={st.otherFormats} key={`other-format-${idx}`}>
        <PrimaryButton href={action.link} forceDoubleHeight={true}>
          <Text tag="span" string={action.text}/>
        </PrimaryButton>
      </div>
    })}
  </div>
}